import axios from 'axios';
import Config from 'core/config';
import Auth from './authToken';

const config = {
  baseURL: '',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

const http = axios.create(config);

http.interceptors.request.use((request) => {
  let authHeader = `${Auth.accessToken}`;

  //  add no cache headers on all requests except Cognito because IE caching
  if (request.url.indexOf(Config.cognitoUrl) === -1) {
    request.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    request.headers.Pragma = 'no-cache';
    request.headers.Expires = 0;
    authHeader = Auth.authToken && `Bearer ${Auth.authToken}`;
  }

  if (authHeader) {
    request.headers.Authorization = authHeader;
  }

  return request;
});

http.interceptors.response.use(response => response.data, (error) => {
  if (error.response && error.response.status === 403) {
    if (error.response.config.url.indexOf('/profile') !== -1 && error.response.config.headers.Authorization) {
      // do nothing if the user is logged in and the request = profile
    } else {
      Auth.remove();
      window.location.href = window.location.origin + '/login';
    }
  }

  if (error.response.status === 401) {
    return Promise.reject('Unauthorized');
  }

  return Promise.reject(error.response ? error.response : error);
});

export default http;
